<!--  -->
<template>
  <div>
    <div class="select_box">
      <div>
        <div class="outerLayer_groupingArea">
          <div class="left">
            <span class="left_title">是否公用</span>
            <ul class="left_ul">
              <li
                class="ul_li"
                :class="{active:pageIfon.is_public == 1}"
                @click="lewrurl(1)"
              >否</li>
              <li
                class="ul_li"
                :class="{active:pageIfon.is_public == 2}"
                @click="lewrurl(2)"
              >是</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
        <div
          class="outerLayer_groupingArea"
          style="margin:15px 0px"
        >
          <div class="left">
            <span class="left_title">图片类型</span>
            <ul class="left_ul">
              <li
                v-for="itemr,index in typelist"
                :key="index"
                :class="{active:pageIfon.business_type == itemr.type}"
                class="ul_li"
                @click="wrw(itemr.type)"
              >{{ itemr.name }}</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
      </div>
      <!-- <div>
        <el-button type="success" icon="el-icon-upload" size="small" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button>
      </div> -->
      <div class="titleArea_right">
        <div>
          <el-upload
            ref="upload"
            class="upload-demo"
            :file-list="fileList"
            action="#"
            :on-success="handleAvatarSuccess"
            :http-request="httpRequest"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :multiple="true"
            :on-change="handleChange"
            :show-file-list="false"
            :limit="100"
          >
            <el-button
              size="small"
              type="primary"
              plain
            >点击上传</el-button>
          </el-upload>
          <canvas
            id="mycanvas"
            style="display: none"
          />
        </div>
      </div>
    </div>

    <div
      v-if="imgarrs.length!=0"
      class="imgbox"
    >
      <div
        v-for="(item,index) in imgarrs"
        :key="index"
        class="imgboxew"
      >
        <img
          :src="item.path"
          class="item-img"
          @click="handitem(item.path,item.id)"
        >
      </div>
    </div>
    <div
      v-else
      class="zanewr"
    >暂无数据</div>

    <pagination-right
      :total="total"
      :page-sizes="[10,20,30,50]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>

</template>

<script>
import { getMaterialLibraryList, materialroadtype, newMateriallist } from '@/api/sourceMaterial.js'
import { getQcConfig, storeBatchQc } from '@/api/sourceminiprogram.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  props: {
    imgarr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      imgarrs: [],
      typer: null,
      total: null,
      pageIfon: {
        type: 1,
        page: 1,
        pageSize: 10,
        is_public: 1,
        business_type: 0
      },
      typelist: [],
      token: null,
      temporary: null,
      fileList: [],
      showProgress: false,
      percentage: 0,
      showModal: false,
      uploadedVideoshow: false
    }
  },
  created() {
    this.mawlist()
  },
  mounted() {},
  methods: {
    handleAvatarSuccess(res, file) {
      console.log('res, fil=====e:', res, file)
    },
    beforeAvatarUpload(file) {
      this.uploadFile = file
    },
    handleChange(file, fileList) {
      console.log(1)
      this.uploadedVideoshow = false
      this.uploadedVideoCount++
      this.imgloding = false
      fileList.forEach(info => {
        // eslint-disable-next-line eqeqeq
        // if (file.uid != info.uid) {
        //   this.deletefile(info.raw)
        // }
      })

      if (fileList.length > 0) {
        const existingUIDs = this.fileList.map(info => info.uid)
        const processedFiles = fileList.map(info => {
          return {
            ...info,
            name: info.name && info.name.replace(/\s/g, '') // 名字去除空格
          }
        })
        const newFiles = processedFiles.filter(info => !existingUIDs.includes(info.uid))
        this.fileList.push(...newFiles)
      }
    },
    async httpRequest(e) {
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      const img = new Image()
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options)
            // this.ruleForm.chapter_pay_cover = res.files[0].options.Key
            // this.$forceUpdate()
            arr.push({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: res.files[0].options.Key
            })
            // this.$refs.men.style.height = 0
            setTimeout(async() => {
              await storeBatchQc({ list: arr, business_type: _this.pageIfon.business_type, is_public: this.pageIfon.is_public })
              await this.getlist()
              this.temporary = null
            }, 500)
            // console.log(arr)
            _this.showProgress = false
            this.percentage = 0
            this.getlist()
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
      // else if (fileType.startsWith('video/')) {
      //   const videoElement = document.createElement('video')
      //   videoElement.src = URL.createObjectURL(fileIfon)
      //   videoElement.addEventListener('loadedmetadata', function() {})
      //   videoElement.addEventListener('loadedmetadata', function() {
      //     videoWidth = videoElement.videoWidth // 视频宽度（以像素为单位）
      //     videoHeight = videoElement.videoHeight // 视频高度（以像素为单位）
      //     // console.log('视频宽度: ' + videoWidth + 'px')
      //     // console.log('视频高度: ' + videoHeight + 'px')
      //   })
      //   // 视频验证
      //   const video = document.createElement('video')
      //   video.src = URL.createObjectURL(fileIfon)
      //   video.onloadedmetadata = function() {
      //     // 获取视频时长
      //     // const videoDuration = video.duration
      //     // 限制视频时长不超过 10 分钟 (600 秒)
      //     // const isWithinDurationLimit = videoDuration <= 600
      //     // if (!isWithinDurationLimit) {
      //     //   this.fileList = this.fileList.filter((item) => item.uid !== fileIfon.uid)
      //     //   this.$message.error('视频时长超过限制，上传失败')
      //     //   return false
      //     // }
      //     // 限制视频大小不超过 700MB
      //     const isWithinSizeLimit = fileIfon.size / 1024 / 1024 < 700
      //     if (!isWithinSizeLimit) {
      //       this.fileList = this.fileList.filter(item => item.uid !== fileIfon.uid)
      //       this.$message.error('请上传不超过700MB的视频')
      //       return false
      //     }

      //     // 视频格式验证
      //     const videoFormats = ['video/mp4', 'video/quicktime']
      //     const isValidVideoFormat = videoFormats.includes(fileIfon.type)
      //     if (!isValidVideoFormat) {
      //       this.fileList = this.fileList.filter(item => item.uid !== fileIfon.uid)
      //       this.$message.error('视频格式有误，上传失败')
      //       return false
      //     }
      //   }
      //   _this.showProgress = true
      //   this.percentage = 0
      //   await uploadFilesimg(
      //     fileIfon,
      //     (num, id) => {
      //       this.percentage = num
      //     },
      //     'operation',
      //     this.config
      //   )
      //     .then(async res => {
      //       console.log('res-------:', res.files[0].options)
      //       console.log(this.pageIfon)
      //       // this.ruleForm.qc_key = res.files[0].options.Key
      //       // this.$forceUpdate()
      //       arr.push({
      //         type: 2,
      //         height: videoHeight,
      //         width: videoWidth,
      //         size: fileIfon.size,
      //         key: res.files[0].options.Key
      //       })
      //       // if (arr.length === e.target.files.length) {
      //       // this.$refs.men.style.height = 0
      //       setTimeout(async() => {
      //         await storeBatchQc({ list: arr, business_type: _this.pageIfon.business_type, is_public: this.pageIfon.is_public })
      //         await this.getlist()
      //         this.temporary = null
      //       }, 500)
      //       // console.log(arr)
      //       // }

      //       _this.showProgress = false
      //       this.percentage = 0
      //       this.getlist()
      //     })
      //     .catch(err => {
      //       console.log('err:-----', err)
      //     })
      // }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    async getconfig() {
      const res = await getQcConfig()
      // console.log('res.data.ciphertext:', res.data.ciphertext)
      // const decodedString = atob(res.data.upToken)
      // console.log('decodedString:', decodedString)
      this.config = res.data
    },
    // 获取token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 获取素材库类型列表
    async mawlist() {
      const data = await materialroadtype()
      this.typelist = data.data
      console.log('类型data', data)
    },
    // 获取素材库列表
    getlist() {
      getMaterialLibraryList(this.pageIfon).then(res => {
        console.log('res', res)
        this.imgarrs = res.data.list
        this.total = res.data.total
      })
    },
    handitem(img, key) {
      if (this.typer === '1') {
        console.log('111')
        this.$emit('clickicon', img, key)
      } else if (this.typer === '2') {
        console.log('222')
        this.$emit('kefuicon', img, key)
      } else {
        console.log('333')
        this.$emit('imgcallback', img, key)
      }
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getlist()
    },
    parentHandleclick(e) {
      console.log(e)
      this.typer = e
      this.getlist()
      // this.getQiniuToken()
      this.getconfig()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    async uploadPictures(e) {
      const that = this
      const arr = []
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        console.log('fileIfon', fileIfon)
        const img = new Image()
        const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary
        const options = {
          quality: 0.62,
          noCompressIfLarger: false,
          maxWidth: 1000,
          maxHeight: 1000
        }
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }

        if (ftype !== '.gif') {
          qiniu.compressImage(fileIfon, options).then(data => {
            const observable = qiniu.upload(
              data.dist,
              `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
              this.token,
              {
                fname: fileIfon.name // 文件名
              },
              {
                useCdnDomain: true // cdn域名加速
              }
            )
            observable.subscribe({
              next() {},
              error(err) {
                console.log(err)
              },
              complete: data => {
                arr.push({
                  type: 1,
                  height: img.height,
                  width: img.width,
                  size: fileIfon.size,
                  key: data.key
                })
                if (arr.length === e.target.files.length) {
                  // this.$refs.men.style.height = 0
                  setTimeout(async() => {
                    await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: this.pageIfon.is_public })
                    await this.getlist()
                    this.temporary = null
                  }, 500)
                  // console.log(arr)
                }
              }
            })
          })
        } else {
          const observable = qiniu.upload(
            fileIfon,
            `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
            this.token,
            {
              fname: fileIfon.name // 文件名
            },
            {
              useCdnDomain: true // cdn域名加速
            }
          )
          observable.subscribe({
            next() {},
            error(err) {
              console.log(err)
            },
            complete: data => {
              arr.push({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              })
              if (arr.length === e.target.files.length) {
                // this.$refs.men.style.height = 0
                setTimeout(async() => {
                  await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: this.pageIfon.is_public })
                  await this.getlist()
                  this.temporary = null
                }, 500)
                // console.log(arr)
              }
            }
          })
        }
        // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
* {
  list-style-type: none;
  box-sizing: border-box;
}
.active {
  border: 1px solid #67c23a;
  color: #67c23a;
}
.outerLayer_groupingArea {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  .left {
    display: flex;
    align-items: center;
    .left_title {
      font-size: 14px;
    }
    .left_ul {
      display: flex;
      align-items: center;
      .ul_li {
        list-style-type: none;
        // padding: 6px 10px;
        padding: 7px 10px 5px 10px;
        font-size: 13px;
        cursor: pointer;
        border-radius: 6px;
        &:not(.active):hover {
          background-color: rgb(230, 230, 230);
        }
        .active {
          background-color: rgb(202, 202, 202);
        }
      }
    }
  }
  .right {
    .right_span {
      font-size: 12px;
      padding: 6px 10px;
      border-radius: 5px;
      display: inline-block;
      cursor: pointer;
      &:hover {
        background-color: rgb(230, 230, 230);
      }
    }
  }
}
.imgbox {
  display: flex;
  flex-wrap: wrap;
}
.item-img {
  width: 150px;
  height: 150px;
  margin-right: 15px;
}
.imgboxew {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
}
.zanewr {
  text-align: center;
  margin: 10px 0px;
}
.select_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 80px;
}
</style>
